<div class="p-2 flex justify-start items-center gap-2 bg-{{severityColorMap[severity]}}-750/50 rounded-xl text-white font-bold">{{content}}</div>